import { render } from "./Chat.vue?vue&type=template&id=207e2f72&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=207e2f72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207e2f72"]])

export default __exports__